import { Log, apiRequest, Paginacion } from '@ext/utils';
export * from './Imagenes.types';
import { IImagen } from './Imagenes.lib';

export class Imagen extends IImagen
{

    public static async create( id: number ): Promise<Imagen>
    {
        let o = new Imagen();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }
    protected Route: string = '/articulos/imagenes';
    protected async find(): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        request.path = `${this.Route}/${this.Id}`;
        if ( await request.get() )
        {
            this.Json = request.data;
            this.set();
        }
        return this.Existe;
    }

    public static async find( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Imagen>; Error?: boolean; }>
    {

        let a: Array<Imagen> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/articulos/imagenes` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Imagen( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save(): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            else
            {
                req.path = `${this.Route}`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                }
            }
            return true;
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del(): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async MarcarPrincipal( es: boolean ): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${this.Route}/${this.Id}`;
                req.body = {};
                if ( es )
                    req.body.tipo = 'principal';
                else
                    req.body.tipo = 'ninguno';
                if ( await req.put() )
                {
                    if ( es )
                        this.Tipo = 'principal';
                    else
                        this.Tipo = 'ninguno';
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }
}